<!-- <script lang="ts">
import mdCheckbox from '../vendor/components/mdCheckbox/mdCheckbox.vue';
const SMCheckbox = { ...mdCheckbox, name: 'SMCheckbox' };
export default SMCheckbox;
</script> -->

<template>
  <label class="inline-flex items-center cursor-pointer">
    <input
      type="checkbox"
      class="border-0 rounded-md text-blue-600 focus:ring-transparent w-4 h-4"
      :checked="modelValue"
      @change="onChange"
    />
    <span class="ml-1 text-sm text-gray-700">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  label: {
    type: String as PropType<string>,
    required: false,
  },
});

const emit = defineEmits(['update:modelValue', 'change']);

const onChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
  emit('change', target.checked);
};
</script>
